import React, { useState } from "react";
import RiskRatingTab from "../RiskRating/index";
import SubmittedFormView from "../../SubmittedFormsView/index";
import { ShieldExclamationIcon } from "@heroicons/react/solid";
import CustomButton from "../../../common/Button/CustomButton";
import { RiFileWarningLine } from "react-icons/ri";
import {
  PARENT_FORM_CATEGORY_SLUG,
  USER_ROLE,
} from "../../../../Constants/constant";
import riskGuide3 from "../../../../assets/riskGuide/guide3.jpg";
import riskGuide1 from "../../../../assets/riskGuide/guide1.jpg";
import riskGuide2 from "../../../../assets/riskGuide/guide2.jpg";
import ModalSkeleton from "../../../Modals/ModalSkeleton";
import { classNames } from "Utils/utils";
import { roleAccess } from "helpers/RolesPermission";

const RiskManagementTab = (props) => {
  const { participantInfoUUID, participantId, parentSlug } = props;
  const [riskToggleState, setRiskToggleState] = useState(1);
  const [isRiskMitigation, setIsRiskMitigation] = useState(false);
  const [isRiskMgt, setIsRiskMgt] = useState(false);
  const [isRiskRating, setIsRiskRating] = useState(false);

  const closeModal = () => {
    setIsRiskMitigation(false);
    setIsRiskMgt(false);
    setIsRiskRating(false);
  };

  const riskMitigation = () => (
    <div className='w-[100%] flex justify-center'>
      <img src={riskGuide3} alt='risk guide' className=' w-[730px] h-[600px]' />
    </div>
  );
  const riskMgt = () => <img src={riskGuide1} alt='risk guide' className='' />;
  const riskRating = () => (
    <div className='w-[100%] flex justify-center'>
      <img
        src={riskGuide2}
        alt='risk guide'
        className='object-contain w-[635px] h-[470px]'
      />
    </div>
  );

  const modalFooter = () => (
    <CustomButton
      title='Close'
      label='Close'
      clickHandler={() => closeModal()}
      variant='danger'
    />
  );

  return (
    <>
      <div className='space-y-6'>
        {!roleAccess([]) && (
          <div className='bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden'>
            {/* Modern Tab Navigation */}
            <div className='px-4 sm:px-6 py-4 border-b border-gray-200 bg-gray-50'>
              <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4'>
                <nav className='flex space-x-1' aria-label='Tabs'>
                  <button
                    onClick={() => setRiskToggleState(1)}
                    className={classNames(
                      riskToggleState === 1
                        ? "bg-blue-600 text-white shadow-sm"
                        : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-300",
                      "inline-flex items-center px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200"
                    )}
                    aria-current={riskToggleState === 1 ? "page" : undefined}
                  >
                    <RiFileWarningLine
                      className={classNames(
                        riskToggleState === 1
                          ? "text-white"
                          : "text-gray-500",
                        "mr-2 h-5 w-5"
                      )}
                      aria-hidden='true'
                    />
                    <span>Risk Assessment</span>
                  </button>

                  <button
                    onClick={() => setRiskToggleState(2)}
                    className={classNames(
                      riskToggleState === 2
                        ? "bg-blue-600 text-white shadow-sm"
                        : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-300",
                      "inline-flex items-center px-4 py-2 rounded-lg font-medium text-sm transition-all duration-200"
                    )}
                    aria-current={riskToggleState === 2 ? "page" : undefined}
                  >
                    <ShieldExclamationIcon
                      className={classNames(
                        riskToggleState === 2
                          ? "text-white"
                          : "text-gray-500",
                        "mr-2 h-5 w-5"
                      )}
                      aria-hidden='true'
                    />
                    <span>Risk Rating</span>
                  </button>
                </nav>

                <div className='flex flex-wrap gap-2'>
                  <CustomButton
                    label='Risk MGT'
                    cssClass='!text-xs !px-3 !py-1.5'
                    clickHandler={() => setIsRiskMgt(true)}
                    variant='secondary'
                  />
                  <CustomButton
                    label='Risk Rating'
                    cssClass='!text-xs !px-3 !py-1.5'
                    clickHandler={() => setIsRiskRating(true)}
                    variant='secondary'
                  />
                  <CustomButton
                    label='Risk Mitigation'
                    cssClass='!text-xs !px-3 !py-1.5'
                    clickHandler={() => setIsRiskMitigation(true)}
                    variant='secondary'
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Content Area */}
        <div className='mt-6'>
          {riskToggleState === 1 && participantInfoUUID && (
            <SubmittedFormView
              parentSlug={parentSlug}
              participantId={participantId}
              supportPlansId={PARENT_FORM_CATEGORY_SLUG.RISK_MANAGEMENT.UUID}
              participantsUid={participantInfoUUID}
            />
          )}
          {riskToggleState === 2 && participantInfoUUID && (
            <div>
              <RiskRatingTab participantsUid={participantInfoUUID} />
            </div>
          )}
        </div>
      </div>
      {isRiskMitigation && (
        <ModalSkeleton
          isOpen={isRiskMitigation}
          closeModal={closeModal}
          modalFooter={modalFooter()}
          cssClass='w-[60%]'
          title='Risk Mitigation'
        >
          {riskMitigation()}
        </ModalSkeleton>
      )}
      {isRiskMgt && (
        <ModalSkeleton
          isOpen={isRiskMgt}
          closeModal={closeModal}
          modalFooter={modalFooter()}
          cssClass='w-[60%]'
          title='Risk MGT'
        >
          {riskMgt()}
        </ModalSkeleton>
      )}
      {isRiskRating && (
        <ModalSkeleton
          isOpen={isRiskRating}
          closeModal={closeModal}
          modalFooter={modalFooter()}
          cssClass='w-[60%]'
          title='Risk Rating'
        >
          {riskRating()}
        </ModalSkeleton>
      )}
    </>
  );
};
export default RiskManagementTab;
